"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class BeaconDto {
    constructor(params) {
        this.uuid = "";
        this.label = "";
        this.subject = "";
        this.message = "";
        this.interval = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.imageId = params.imageId;
        this.attachmentId = params.attachmentId;
        this.major = params.major;
        this.minor = params.minor;
        this.timeout = params.timeout;
        this.uuid = params.uuid;
        this.label = params.label;
        this.subject = params.subject;
        this.message = params.message;
        this.interval = params.interval;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.BeaconDto = BeaconDto;
//# sourceMappingURL=BeaconDto.js.map